'use strict'

import Swiper from 'swiper';

const $ = window.jQuery;

export default function () {
    // Services
    const historySlider = new Swiper('#historySlider', {
        parallax: true,
        grabCursor: true,
        speed: 400,
        navigation: {
            prevEl: '#historyPrev',
            nextEl: '#historyNext'
        }
    });

    $('.history-slide__date').on('click', function () {
        const clickedIndex = $(this).data('index');

        historySlider.slideTo(clickedIndex);
    });
};
